module.exports = __webpack_public_path__ + "static/img/emptyData.32755e73.png";